// Session storage for the platform admin console — structurally identical to
// lib/api/session.ts but with NON-OVERLAPPING localStorage keys. A ClintoBytes
// staffer could plausibly have a tenant login (?) open in one tab and the
// platform console open in another, and the two sessions must never collide
// or be readable as one another.

const PLATFORM_TOKEN_KEY = 'hms_platform_token';
const PLATFORM_OPERATOR_KEY = 'hms_platform_operator';

export interface PlatformOperator {
  id: number;
  username: string;
  full_name: string;
}

export function getPlatformToken(): string | null {
  return localStorage.getItem(PLATFORM_TOKEN_KEY);
}

export function getPlatformOperator(): PlatformOperator | null {
  try {
    return JSON.parse(localStorage.getItem(PLATFORM_OPERATOR_KEY) || 'null') as PlatformOperator | null;
  } catch {
    return null;
  }
}

export function setPlatformSession(token: string, operator: PlatformOperator): void {
  localStorage.setItem(PLATFORM_TOKEN_KEY, token);
  localStorage.setItem(PLATFORM_OPERATOR_KEY, JSON.stringify(operator));
}

export function clearPlatformSession(): void {
  localStorage.removeItem(PLATFORM_TOKEN_KEY);
  localStorage.removeItem(PLATFORM_OPERATOR_KEY);
}
